<script>

    export default {
        data () {
            return {
                selectedTab: 1
            }
        },
        props: {
        },
        mounted () {

        },
        methods: {
            tabSelected(id) {
                return (id == this.selectedTab) ? true : false
            },
            selectTab(id) {
                this.selectedTab = id
            }
        }
    }
</script>